import axios from "axios";
import CacheService from "./cache.service";
import CACHEKEYS from "../cacheKeys";
import Constants from "../constants";
const API = `/api/user`;

const _getEditUserPayload = (editedUser, newpass) => {
  if (newpass.length !== 0) {
    return {
      ...editedUser,
      username: editedUser.username,
      password: newpass,
    };
  }
  return editedUser;
};

const getUser = async (username, password) => {
  CacheService.clear();
  try {
    const authResponse = await axios.get(`${API}`, {
      headers: {
        "x-header-authid": username,
        "x-header-ticket": password,
      },
    });
    const authData = authResponse.data;
    if (authData.status === "failed") return null;
    return authData.payload;
  } catch (error) {
    return null;
  }
};

const getAllUsers = async (user) => {
  if (user["type"] === Constants.user_type.USER) return [];
  try {
    const cachkey = CACHEKEYS.FETCH_USERS;
    const cachevalue = CacheService.get(cachkey);
    if (cachevalue !== null) return cachevalue;
    const response = await axios.get(`${API}/${user["id"]}/users`);
    const data = response.data;
    if (data.payload.status === "failed") return [];
    CacheService.set(cachkey, data.payload);
    return data.payload;
  } catch (error) {
    return [];
  }
};

const createUser = async (newuser) => {
  try {
    await axios.post(`${API}`, newuser);
    CacheService.remove(CACHEKEYS.FETCH_USERS);
    return "success";
  } catch (error) {
    return "failed";
  }
};

const editUser = async (admin, editedUser, newpassword = "") => {
  try {
    const user = _getEditUserPayload(editedUser, newpassword);
    await axios.put(`${API}`, user);
    CacheService.remove(CACHEKEYS.FETCH_USERS);
    return "success";
  } catch (error) {
    return "failed";
  }
};



const deleteUser = async (admin, usertoDelete) => {
  try {
    await axios.delete(`${API}/${usertoDelete["id"]}`);
    CacheService.remove(CACHEKEYS.FETCH_USERS);
    return true;
  } catch (error) {
    return false;
  }
};

export {
  getUser,
  getAllUsers,
  createUser,
  editUser,
  deleteUser,
};
